import { toast } from "react-toastify";
import { requestBackendReportExport } from "./backendReportExport";

export const TARGETING_V2_REPORT_TYPE = "TARGETING";

/** Prefer display name key (innerKeys.productName) over id key for export columns. */
export function getTargetingV2VisibleColumnKeys(columns = []) {
  return columns
    .map((column) => {
      if (typeof column === "string") return column;
      return column?.innerKeys?.productName ?? column?.key;
    })
    .filter(Boolean);
}

export function buildTargetingV2WrapperExportQueryBody({ query }) {
  return {
    query: { ...query },
  };
}

export async function exportTargetingV2Report({
  clientId,
  userPlatform = "amazon",
  triggeredBy,
  totalCount,
  queryBody,
  visibleColumnKeys,
  isComparison = false,
  frontendConfig = {},
  setIsExporting = () => {},
  onExportSuccess = () => {},
}) {
  try {
    setIsExporting(true);

    await requestBackendReportExport({
      clientId,
      userPlatform,
      reportType: TARGETING_V2_REPORT_TYPE,
      totalCount,
      triggeredBy,
      queryBody,
      frontendConfig: {
        columns: visibleColumnKeys,
        ...(isComparison ? { is_comparison: true } : {}),
        ...frontendConfig,
      },
    });

    onExportSuccess();
  } catch (error) {
    console.error(error);
    toast.error(
      error?.response?.data?.message ?? "Failed to submit export request."
    );
  } finally {
    setIsExporting(false);
  }
}
